function dataLink() {
    if ($('*[data-link]').length) {
        var res = resolutionCheck();
        $('*[data-link]').each(function() {
            var link = $(this).attr('data-link');
            if (res > 64) {
                $(this).prop('href', link);
            } else {
                $(this).removeAttr('href');
            }
        });
    }
}
$(document).ready(function() {
    dataLink();
});
$(window).on('resize orientationchange', function() {
    dataLink();
});
